var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var InvisibleTestElement = function (_a) {
    var dataTestId = _a.dataTestId;
    return React.createElement(InvisibleEl, { "data-testid": dataTestId || 'InvisibleTestElement' });
};
var InvisibleEl = styledWithTheme('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
var templateObject_1;
